import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from 'shared/components/inputs/TextInput/TextInput';
import { SearchIcon } from 'shared/components/icons/SearchIcon';
import { SearchBar } from './FAQSearchBar.styles';

export function FAQSearchBar({
  onChange,
  onSearch,
}: {
  onChange: (val: string) => void;
  onSearch: () => void;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'support&FAQs' });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <SearchBar>
      <TextInput
        ariaLabel={t('searchFAQs', { keyPrefix: 'support&FAQs' })}
        placeholder={t('searchFAQs', { keyPrefix: 'support&FAQs' })}
        hasLabel={false}
        LeftIcon={SearchIcon}
        onChange={handleSearchChange}
        onKeyUp={handleKeyPress}
        onIconClick={onSearch}
      />
    </SearchBar>
  );
}

export default FAQSearchBar;
